module.exports = __webpack_public_path__ + "img/logo-sesb.39686d89.png";